import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VBtn,_vm._b({attrs:{"loading":_vm.loading,"depressed":""},on:{"click":_vm.reindexHandler}},'v-btn',_vm.$attrs,false),[_vm._v(" "+_vm._s(_vm.$attrs.label || _vm.$t('Reindex'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }